import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../../api';

// MedicalDropdown Component
// A dropdown to fetch and display medical centers dynamically from API
const MedicalDropdown = ({ value, onChange, disabled, className = '', error, roleName }) => {
  // State to store fetched medical centers
  const [medicalCenters, setMedicalCenters] = useState([]);
  // State to track loading status
  const [loading, setLoading] = useState(true);
  // State to hold error message (if any)
  const [errorMsg, setErrorMsg] = useState(null);

  // Fetch medical centers on component mount
  useEffect(() => {
    const fetchMedicalCenters = async () => {
      try {
        // API call with specific headers
        const response = await axiosInstance.get('/ems/medical-centers');
        
        // Extract data safely (handles both `data.data` and `data`)
        const centers = response.data.data || response.data || [];
        setMedicalCenters(centers); // Save centers in state
      } catch (err) {
        console.error('Error fetching medical centers:', err); // Log error
        setErrorMsg('Failed to load medical centers'); // Show fallback error msg
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchMedicalCenters();
  }, []);

  // Helper to extract center name (handles different response formats)
  const getCenterName = (center) => {
    return center.attributes?.name || center.name || 'Unknown';
  };

  // Show loading state dropdown
  if (loading) {
    return (
      <select className={`form-select ${className}`} disabled>
        <option>Loading medical centers...</option>
      </select>
    );
  }

  // Show error state dropdown
  if (errorMsg) {
    return (
      <select className={`form-select ${className}`} disabled>
        <option>{errorMsg}</option>
      </select>
    );
  }

  // Final rendered dropdown with medical centers
  return (
    <div>
      <select
        className={`form-select ${className} ${error ? 'is-invalid' : ''}`} // Apply error class if any
        name="medical_center_id"
        value={value || '0'} // Default to '0' (string to avoid React warnings)
        onChange={e => {
          console.log(`Medical center changed: ${e.target.value}`); // Debug log
          onChange(e); // Trigger parent handler
        }}
        disabled={disabled} // Disable if prop is true
      >
        {/* Default option changes based on role */}
        <option value="0">
          {roleName === 'EMS Resource Manager' ? 'All' : 'Select Medical Center'}
        </option>
        
        {/* Render all centers as options */}
        {medicalCenters.map((center) => (
          <option key={center.id} value={center.id}>
            {getCenterName(center)}
          </option>
        ))}
      </select>

      {/* Show error message if validation fails */}
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default MedicalDropdown;
